import type { FC } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Banner, FlexRow, NavItemBadge } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { BADGE_ITEMS } from "app/components/sidebar3/types";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const StyledBanner = styled(Banner)`
    padding: 24px;
    border-radius: 6px;
    background-color: ${colorsPalettes.blue[100]};
`;
const TitleContainer = styled(FlexRow)`
    align-items: center;
`;
interface ILobBannerProps {
    onClose: () => void;
}
const LobEducationBanner: FC<ILobBannerProps> = ({ onClose }) => {
    const handleClose = () => {
        allTrackers.dispatchTrackEvent("Button", "click", `EducationBanner/dismiss banner`);
        onClose();
    };
    const handleClick = () => {
        allTrackers.dispatchTrackEvent("Button", "click", `EducationBanner/open link`);
        window.open("https://support.similarweb.com/hc/en-us/articles/28193039383709-Business-Lines");
    };
    return (
        <StyledBanner
            onCloseClick={handleClose}
            onButtonClick={handleClick}
            buttonText={translate("learn.more")}
            buttonType="flat"
            buttonIconName="Help-icon"
            title={
                <FlexColumn>
                    <TitleContainer>
                        <Text
                            fontVariant="subtitle1"
                            color={colorsPalettes.carbon[500]}
                        >
                            {translate("analysis.content.lob.banner")}
                        </Text>
                        <NavItemBadge type={BADGE_ITEMS.BETA} />
                    </TitleContainer>
                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.carbon[500]}
                    >
                        {translate("analysis.content.lob.banner.subtitle")}
                    </Text>
                </FlexColumn>
            }
            CustomIcon={
                <SWReactIcons
                    iconName="affiliates-green"
                    size="lg"
                />
            }
        />
    );
};

export default LobEducationBanner;
